import api from "../api.ts";
import { OnboardingData } from "@/types/onboarding";

export interface CreateTenantResponse {
  success: true;
}

const PAYLOAD = (data: OnboardingData) => ({
  name: data.libraryName,
  slug: data.domainPrefix,
  domains: [`${data.domainPrefix}.philolms.com`],
  libraryType: data.libraryType,
  defaultLocale: data.defaultLocale,
  admin: {
    email: data.adminEmail,
    password: data.adminPassword,
    firstName: data.adminFirstName,
    lastName: data.adminLastName,
  },
  contact: {
    phone: data.contactPhone || undefined,
    address: data.address || undefined,
    city: data.city || undefined,
    state: data.state || undefined,
    country: data.country || undefined,
    postalCode: data.postalCode || undefined,
  },
});

export async function createTenant(
  data: OnboardingData,
  options?: { retryOnServerError?: boolean }
): Promise<CreateTenantResponse> {
  const retryOnServerError = options?.retryOnServerError !== false;

  const attempt = async (isRetry: boolean): Promise<CreateTenantResponse> => {
    try {
      const response = await api.post("/tenants/onboard", PAYLOAD(data));
      return response.data;
    } catch (error: any) {
      const status = error.response?.status;
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Failed to create library. Please try again.";

      if (status === 500 && retryOnServerError && !isRetry) {
        await new Promise((r) => setTimeout(r, 2500));
        return attempt(true);
      }

      throw new Error(message);
    }
  };

  return attempt(false);
}
